import angular from 'angular';
import { visualTagPickerComponent } from './visualTagPickerComponent';
import 'components/sharpr/hoverIn/hoverInModule';

angular.module('sh.visualTagPicker', ['sh.hoverIn']).component('shVisualTagPicker', visualTagPickerComponent());
